import { Injectable } from '@angular/core';
import { Http, RequestOptions, URLSearchParams, ResponseContentType, RequestMethod, Headers } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../environments/environment';

import { Recensione } from '../models/Recensione';

@Injectable()
export class RecensioneService {
  selectedId: string;

  get selected(): string {
    return this.selectedId;
  }
  set selected(id: string) {
    this.selectedId = id;
  }

  getRecensione(id: string) {
    console.log('getRecensione', id)
    return this.http.post(environment.server.url + '/recensione/find-one', { id: id })
      .map(response => response.json())
  }

  persist(wmodel: any) {
    console.log('persistRecensione', wmodel)
    return this.http.post(environment.server.url + '/recensione/persist', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('persistRecensione', r)

        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  remove(wmodel: Recensione) {
    console.log('removeRecensione', wmodel)
    return this.http.post(environment.server.url + '/recensione/remove', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('removeRecensione', r)
        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  search(opt) {
    console.log('recensione service', opt)
    return this.http.post(environment.server.url + '/recensione/search', opt)
      .map(response => response.json())
      .catch(this.handleError)
  }

  constructor(private http: Http) { }

  private handleError(error: Response | any) {
    console.error(error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/recensione.service.ts